import '../TableofRequests.sass';
import { ChangeEvent, SyntheticEvent, useEffect, useLayoutEffect, useMemo, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../hooks/hooks';
import { appealsFromAppApiI } from '../../../interfaces/appealsAPI';
import SingleAppeal from '../../SingleAppeal/SingleAppeal';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import SkeletonList from '../../SkeletonList/SkeletonList';
import {
  useChangeOperatorMutation,
  useChangePhoneResponseMutation,
  useChangePriorityMutation,
  useChangeResponseMutation,
  useChangeStatusMutation,
  useFetchAllAppealsFromAppQuery,
  useChangeDraftMutation,
  useGetAppealHistoryQuery,
} from '../../../store/appealsFromAppAPI';
import ModalForm from '../../ModalForm/ModalForm';
import { callModal, closeModal, useResendAppealMutation } from '../../../store/modalSlice';
import { ModalDataI } from '../../../interfaces/modal';
import { paginationAppeals } from '../../paginationAppeals/paginationAppeals';
import { countingPassedDays } from '../functions';
import WithLoader from '../../Spinner/WithLoader';
import cn from 'classnames';
import { baseURL } from '../../../services/api';
import { constURL } from '../../../services/enum.services';
import ModalComponent from '../../ModalComponent/ModalComponent';
import { Alert, Snackbar } from '@mui/material';
import { responsePatternApp, responsePatternAppWater } from '../../ModalForm/responsePattern';
import { OperatorsSubListI } from '../../../interfaces/filters';


interface RequestsFromAppProps {
  selectedAppeals: { [id: string]: boolean };
  onCheckBoxChange: (id: string, checked: boolean) => void;
  setListSubUsers: (list: OperatorsSubListI[]) => void;  // функция для передачи списка операторов наверх
}


const RequestsFromApp = ({ selectedAppeals, onCheckBoxChange, setListSubUsers }: RequestsFromAppProps) => {            // главная страница (РОДИТЕЛЬ) строит всю структуру, из нее передаются данные в SingleAppeal.tsx
  const dispatch = useAppDispatch();
  const [currentPage, setCurrentPage] = useState<number>(1);

  const [appealDate, setAppealDate] = useState('');
  const [appealId, setAppealId] = useState('');
  const [dateResponse, setDateResponse] = useState('');
  const [appealResponseText, setAppealResponseText] = useState('');
  const [appealDraftText, setAppealDraftText] = useState('');
  const [appealFio, setAppealFio] = useState('');
  const [appealLogin, setAppealLogin] = useState('');
  const [appealEmail, setAppealEmail] = useState('');
  const [appealPhone, setAppealPhone] = useState('');
  const [appealAddress, setAppealAddress] = useState('');
  const [appealQestion, setAppealQestion] = useState('');
  const [appealFiles, setAppealFiles] = useState<Array<string>>([]);
  const [appealQuestionStatus, setAppealQuestionStatus] = useState('');

  const [modalResendId, setModalResendId] = useState<string>('');                                   //modalResend
  const [showSnack, setShowSnack] = useState(false);
  const { isOpen } = useAppSelector((state) => state.modal);
  const { role: userRole, id: userId } = useAppSelector((state) => state.user);
  const filters = useAppSelector((state) => state.filters);

  const {
    priority,
    questionStatus,
    firstDate,
    lastDate,
    typeSearch,
    searchQuery,
    term,
    source,
    operator_id,
    operator_sub_id,
    quesTheme,
  } = filters;

  const handleChangePage = (event: ChangeEvent<unknown>, value: number) => {
    setCurrentPage(value);
    refetchList();
  };
  const handleCloseModalSend = () => {
    setModalResendId('');
  };
  const handleOpenModalSend = (appealId: string) => {
    setModalResendId(appealId);
  };
  const handleCloseModal = () => {
    dispatch(closeModal());
  };

  const handleCallModal = (props: ModalDataI) => {
    const { 
      appealId,
      appealDate,
      dateResponse,
      appealResponseText,
      appealDraftText,
      appealFio,
      appealLogin,
      appealEmail,
      appealPhone,
      appealAddress,
      appealQestion,
      appealFiles,
      appealQuestionStatus,
     } = props;
    setAppealId(appealId);
    setAppealDate(appealDate);
    setDateResponse(dateResponse);
    setAppealResponseText(appealResponseText);
    setAppealDraftText(appealDraftText);
    setAppealFio(appealFio);
    setAppealLogin(appealLogin);
    setAppealEmail(appealEmail);
    setAppealPhone(appealPhone);
    setAppealAddress(appealAddress);
    setAppealQestion(appealQestion);
    setAppealFiles(appealFiles ?? []);
    setAppealQuestionStatus(appealQuestionStatus);
    dispatch(callModal());
    refetch();
  };

  const handleCloseSnack = (event?: SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setShowSnack(false);
  };

  const handleResend = (email: string) => {
    resendAppeal({ appealId: modalResendId, email, type: 'App' });
  };

  const {
    data: response,
    isLoading,
    isFetching,
    error,
    refetch: refetchList,
  } = useFetchAllAppealsFromAppQuery(     // здесь я получаю список всех обращений
    {
      page: currentPage,
      priority,
      // @ts-ignore
      activeOperator: userRole !== '3' && userRole !== '4' ? operator_id : userId,
      questionStatus,
      firstDate,
      lastDate,
      typeSearch,
      searchQuery,
      term,
      source,
      role: userRole,
      filterOperator: operator_sub_id,
      quesTheme,
    }
  );
  
  const [                          // получаем данные об ответе из мутации
    changeResponse,
    {
      error: changeResponseError,
      data: changeResponseData,
      isSuccess: isSuccessChangeResponse,
      isError: isErrorChangeResponse,
    },
  ] = useChangeResponseMutation();

  const [                      // получаем данные о черновике из мутации
    changeDraft,
    {
      error: changeDraftError,
      data: changeDraftData,
      isSuccess: isSuccessChangeDraft,
      isError: isErrorChangeDraft,
    },
  ] = useChangeDraftMutation();    

  const [changeStatus, { error: changeStatusError }] = useChangeStatusMutation();
  const [changePriority, { error: changePriorityError }] = useChangePriorityMutation();
  const [changePhoneResponse, { error: changePhoneResponseError }] = useChangePhoneResponseMutation();
  const [changeOperator, { error: changeOperatorError }] = useChangeOperatorMutation();     

  const { data: appealHistoryResponse, refetch } = useGetAppealHistoryQuery(appealId);
  const appealHistory = appealHistoryResponse ?? [];
  
  const responsePatternToggle = () => {
    if (userRole === '2') {
      return responsePatternApp
    } else if (userRole === '4' || userId === '95') {
      return responsePatternAppWater
    }
    return []
  }

  console.log('кто авторизовался?', userId)

  const responsePatternValue = useMemo(() => responsePatternToggle(), [userRole])

  const [
    resendAppeal,
    { isError: isErrorResend, isSuccess: isSuccessResend, data: resendData, error: resendError },
  ] = useResendAppealMutation();

  const modalProps = {
    appealId,
    appealDate,
    dateResponse,
    appealResponseText,
    appealDraftText,
    appealFio,
    appealLogin,
    appealEmail,
    appealPhone,
    appealAddress,
    appealQestion,
    appealHistory,
    appealFiles,
    appealQuestionStatus,
    handleCloseModal,
    changeResponse,
    changeOperator,
    changeStatus,
    changePriority,
    changePhoneResponse,
    changeDraft,
    // responsePattern: userRole === '2' ? responsePatternApp : responsePatternAppWater,
    responsePattern: responsePatternValue,
  };

  useEffect(() => {
    if (response?.listSubUsers) {
      setListSubUsers(response.listSubUsers);
    }
  }, [response, setListSubUsers]);
 

  const renderAppeals = (appealsProps: appealsFromAppApiI) => {       // отрисовка главной страницы (передаем данные в SingleAppeal.tsx для отрисовки каждой жалобы (обращения))
    return (
      appealsProps &&
      appealsProps.data.map((el) => {
        return (
          <CSSTransition key={el.id} timeout={500}>
            <SingleAppeal
              {...{
                ...el,
                listUsers: appealsProps.listUsers,
                listSubUsers: appealsProps.listSubUsers,
                changeOperator,
                changePriority,
                changeStatus,
                changePhoneResponse,
                userRole,
                currentUser: userId,
                appealHistory: appealHistory,
              }}
              handleOpen={handleCallModal}
              countingPassedDays={countingPassedDays}
              handleOpenModalSend={handleOpenModalSend}
              isChecked={!!selectedAppeals[el.id.toString()]}
              onCheckBoxChange={onCheckBoxChange}
            />
          </CSSTransition>
        );
      })
    );
  };
 

  // useEffect(() => {
  //   console.log(
  //     `${baseURL}${constURL.APPEALS_APP}?page=${currentPage}&priority=${priority}&operator=${operator.active}&questionStatus=${questionStatus}&firstDate=${date.firstDate}&lastDate=${date.lastDate}&typeSearch=${typeSearch}&searchQuery=${searchQuery}&term=${term}`
  //   );
  // }, [priority, operator, questionStatus, date, typeSearch, searchQuery, term]);


  useEffect(() => {                      // обновление данных (вывод сообщения об успешной отправки ответа или сохранении черновика)
    if (isErrorResend || isSuccessResend || isSuccessChangeResponse || isErrorChangeResponse || isSuccessChangeDraft || isErrorChangeDraft) {
      setShowSnack(true);
    }
    if (isSuccessChangeResponse || isSuccessChangeDraft) {
      handleCloseModal();
    }
  }, [isErrorResend, isSuccessResend, isSuccessChangeResponse, isSuccessChangeDraft, isErrorChangeResponse, isErrorChangeDraft]);

  useLayoutEffect(() => {
    setCurrentPage(1);
  }, [filters]);

  const showPagination = paginationAppeals({ response, currentPage, handleChangePage }); 

  // @ts-ignore
  const appealsList = renderAppeals(response);

  if (isLoading) {
    return <SkeletonList />;
  }
  if (appealsList.length === 0) return <h3>По данным фильтрам результатов не найдено</h3>;


  return (
    <WithLoader loading={isFetching}>
      <div className="table-wrapper">
        {appealsList}
        {error && <h3>Ошибка загрузки</h3>}
        {isOpen && <ModalForm {...modalProps} />}
        {
          <ModalComponent
            isOpenModalSend={!!modalResendId}
            handleCloseModalSend={handleCloseModalSend}
            handleResend={handleResend}
          />
        }
        {
          <Snackbar open={showSnack} autoHideDuration={10000} onClose={handleCloseSnack}>
            <Alert
              onClose={handleCloseSnack}
              severity={isSuccessResend || isSuccessChangeResponse || isSuccessChangeDraft ? 'success' : 'error'}
              sx={{ width: '100%' }}
            >
              {/* @ts-ignore */}
              {resendError && resendError.data.message}
              {resendData && resendData.message}
              {changeResponseData && changeResponseData.message}
              {/* @ts-ignore */}
              {changeResponseError && changeResponseError.data.message}
              {/* @ts-ignore */}
              {changeDraftError && changeDraftError.data.message}
            </Alert>
          </Snackbar>
        }
        <div className="pagination-wrapper">{showPagination}</div>
      </div>
    </WithLoader>
  );
};

export default RequestsFromApp;